import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  button: {
    display: "flex",
    flexDirection: "row",
    minHeight: 44,
    minWidth: 44,
    height: 36,
    width: "fit-content",
    margin: "0 5px",
    padding: "0 15px",
    alignItems: "center",
    alignSelf: "center",
    cursor: "pointer",
    background: "transparent",
    color: ({ mode }) => (mode === "dark" ? "#FFFFFF" : "#0C0B0F"),
    border: "2px solid transparent",
    borderRadius: 999,
    fontFamily: "Inter, sans-serif",
    fontSize: 14,
    outline: "none",
    "&:focus-visible": {
      outline: "2px solid #4484F1",
      outlineOffset: "2px",
    },
    "&:hover:not(:disabled)": {
      backgroundColor: ({ mode }) => (mode === "dark" ? "#FFFFFF" : "#0C0B0F"),
      color: ({ mode }) => (mode === "dark" ? "#0C0B0F" : "#FFFFFF"),
    },
    "&:disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
    },
    "@media (max-width: 700px)": {
      margin: "0 3px",
      padding: "0 8px",
    },
  },
  label: {
    paddingLeft: (props) => (props.iconFirst ? 5 : 0),
    paddingRight: (props) => (!props.iconFirst ? 5 : 0),
    lineHeight: "16px",
  },
  active: {
    background: "#ECEBEF",
    border: "2px solid #0C0B0F",
  },
});

export const Button = ({
  text,
  icon,
  iconFirst = true,
  active,
  onClick,
  dataTip = false,
  dataFor,
  mode,
  ariaLabel,
  disabled = false,
}) => {
  const styles = useStyles({ iconFirst, mode });

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
      e.preventDefault();
      if (!disabled && onClick) {
        onClick(e);
      }
    }
  };

  return (
    <button
      type="button"
      className={`${styles.button} ${active ? styles.active : ""}`}
      onClick={disabled ? undefined : onClick}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      aria-label={ariaLabel || text}
      data-tip={dataTip}
      data-for={dataFor}
    >
      {iconFirst && icon}
      <div className={styles.label}>{text}</div>
      {!iconFirst && icon}
    </button>
  );
};
